import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import DigitalOnboardingViewButton from './DigitalOnboardingViewButton';

const DigitalOnboardingViewButtonPicker = (props) => {
  const { pageContentResource } = usePageContentContext();

  return pickFunction(pageContentResource, {
    [fr.relationships.doProgressView.name]: () => {
      return (
        <DigitalOnboardingViewButton {...props} />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default DigitalOnboardingViewButtonPicker;
